export async function saveVisitWorker(visitId, workerId, { employeeId, userEmail, roleHeader, signal }) {
  const response = await fetch(`/api/shifts/${encodeURIComponent(visitId)}/assignment?employeeId=${encodeURIComponent(employeeId || '167')}`, {
    method: 'PUT',
    signal,
    headers: {
      'Content-Type': 'application/json',
      'x-kcs-user-email': userEmail || '',
      'x-kcs-user-roles': roleHeader,
      'x-kcs-provider-employee-id': employeeId || '167',
    },
    body: JSON.stringify({ workerId: workerId || null }),
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'Unable to save assignment.');
  return result.assignment;
}